export function DecrementSvg() {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="12"
         height="12"
         viewBox="0 0 12 12"
         fill="none"
      >
         <g clipPath="url(#clip0_164_1431)">
            <path
               d="M10.6284 8.34073C10.5817 8.40765 10.5239 8.46632 10.4575 8.51307C10.3901 8.56028 8.78179 9.6534 6.39479 8.42186C6.05745 8.24815 5.925 7.83336 6.0987 7.49557C6.27287 7.15778 6.68812 7.02486 7.025 7.19948C7.71937 7.5579 8.29504 7.64407 8.7332 7.62711L6.44704 5.51923C6.33245 5.41244 6.18075 5.36111 6.03087 5.36386C5.8787 5.37028 5.73754 5.43673 5.63395 5.55132C5.28058 5.94044 4.79795 6.16686 4.275 6.18886C3.75341 6.20948 3.25016 6.02478 2.8647 5.66544C2.84545 5.64757 2.82758 5.62878 2.81108 5.60907L1.19866 3.72348C0.951621 3.43519 0.973163 2.98557 1.27429 2.75411C1.7065 2.42228 2.10754 2.67069 2.2432 2.83019L3.82537 4.68048C3.93583 4.77307 4.06645 4.8189 4.21679 4.81478C4.36941 4.80836 4.51104 4.7419 4.61462 4.62732C4.96754 4.23819 5.44925 4.01178 5.97266 3.98978C6.4947 3.96365 6.99841 4.1534 7.38112 4.51044L9.73191 6.67836C9.76125 6.2269 9.687 5.6219 9.31162 4.88261C9.13975 4.5439 9.27404 4.12865 9.6132 3.95815C10.0582 3.73494 10.4167 4.02094 10.5381 4.25973C11.7559 6.65865 10.6752 8.27244 10.6284 8.33982V8.34073Z"
               fill="#FF5185"
            />
         </g>
         <defs>
            <clipPath id="clip0_164_1431">
               <rect
                  width="11"
                  height="11"
                  fill="white"
                  transform="matrix(1 0 0 -1 0.572266 11.2983)"
               />
            </clipPath>
         </defs>
      </svg>
   )
}
